import { Pipe, PipeTransform } from '@angular/core';

const DEFAULT_BOUND_INSET = 100;
const EXTENDED_BOUND_OUTSET = 500;

@Pipe({
    name: 'tabloBoundArea',
    standalone: false
})
export class TabloBoundAreaPipe implements PipeTransform {
  transform(
    element: HTMLElement,
    scale: number,
    skipPadding = false,
  ): {
    top: number;
    left: number;
    right: number;
    bottom: number;
  } {
    const bounding = element.getBoundingClientRect();
    const padding =
      (skipPadding ? -EXTENDED_BOUND_OUTSET : DEFAULT_BOUND_INSET) * scale;

    return {
      top: bounding.top + padding,
      left: bounding.left + padding,
      right: bounding.right - padding,
      bottom: bounding.bottom - padding,
    };
  }
}
